import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const selectToastAlertState = (state: RootState) => state.toastAlert;

const selectToastAlert = createSelector(
  [selectToastAlertState],
  (toastAlertState) => (toastAlertState.message ? toastAlertState : null),
);

export default selectToastAlert;
